<div class="page-wrap">
  <section class="card-grid">
    <article class="glass-panel editor-card">
      <p class="eyebrow">Template Studio</p>
      <h2 class="section-title">Create approved marketing or utility templates</h2>

      <div [formGroup]="form">
        <div class="form-grid">
          <ion-item>
            <ion-label position="stacked">Template name</ion-label>
            <ion-input formControlName="name"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Category</ion-label>
            <ion-select formControlName="category">
              <ion-select-option value="marketing">Marketing</ion-select-option>
              <ion-select-option value="utility">Utility</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="stacked">Language</ion-label>
            <ion-input formControlName="language"></ion-input>
          </ion-item>
        </div>

        <ion-item>
          <ion-label position="stacked">Body</ion-label>
          <ion-textarea rows="6" formControlName="body"></ion-textarea>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Variables</ion-label>
          <ion-input formControlName="variables"></ion-input>
        </ion-item>

        <ion-button expand="block" (click)="create()">Save template</ion-button>
      </div>
    </article>

    <article class="glass-panel list-card">
      <p class="eyebrow">Saved Templates</p>
      <ion-list lines="full">
        <ion-item *ngFor="let template of templates">
          <ion-label>
            <h3>{{ template.name }}</h3>
            <p>{{ template.category }} · {{ template.language }} · {{ template.variables.join(', ') }}</p>
          </ion-label>
          <ion-badge color="medium">{{ template.status || 'draft' }}</ion-badge>
        </ion-item>
      </ion-list>
    </article>
  </section>
</div>
